module.exports = __webpack_public_path__ + "static/media/AAIB-logo.d9b8ecaf.png";